import React, {Fragment, Suspense} from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import cx from "classnames";
import {
    Card,
    Nav,
    NavLink,
    NavItem,
} from "reactstrap";
import PlanContent from './PlanContent';

class PlansContent extends React.Component{
    
    constructor(props) {
        super(props);

        this.state = {
            active: false,
            currentMenu : {name : 'call_tracking', label : 'Call Tracking', icon : 'pe-7s-home'},
        };
    }

    onSettingsMenuChange = async (e, menu) => {
        this.setState({
            currentMenu : menu
        });
    }

    render() {

        let {
            active,
            currentMenu,
        } = this.state;
        
        const crmSettingsMenu = [
            {name : 'call_tracking', label : 'Call Tracking', icon : 'pe-7s-call'},
            {name : 'call_recording', label : 'Call Recording', icon : 'pe-7s-volume1'},
            {name : 'whatsapp', label : 'WhatsApp', icon : 'pe-7s-chat'},
            {name : 'workflows', label : 'Workflows', icon : 'pe-7s-diamond'},
            {name : 'ffa', label : 'FFA', icon : 'pe-7s-map-2'},
            {name : 'customforms', label : 'Custom Forms', icon : 'pe-7s-bookmarks'},
            {name : 'api', label : 'API', icon : 'pe-7s-key'},
        ];

        return (
            <Fragment>
                <TransitionGroup>
                    <CSSTransition 
                        component="div" 
                        classNames="TabsAnimation" 
                        appear={true}
                        timeout={1500} 
                        enter={false} 
                        exit={false}
                    >
                        <div>
                            <div className={cx("app-inner-layout TabsAnimation", {
                                "open-mobile-menu": active,
                            })}>
                                <div className="app-inner-layout__wrapper">
                                    <Card className="app-inner-layout__content">
                                        <PlanContent
                                            currentMenu={currentMenu}
                                        />
                                    </Card>
                                    <Card className="app-inner-layout__sidebar">
                                        <Nav vertical>
                                            <NavItem className="nav-item-header nav-header-font">Your Plans</NavItem>
                                            {
                                                crmSettingsMenu.map((menu) => {
                                                    return(
                                                        <NavItem>
                                                            <NavLink
                                                                className={cx("", { 'active' : currentMenu.name === menu.name })}
                                                                href="#"
                                                                onClick={(e) => {this.onSettingsMenuChange(e,menu)}}>
                                                                <i className={`nav-link-icon ${menu.icon} `}> </i>
                                                                <span>{menu.label}</span>
                                                            </NavLink>
                                                        </NavItem>
                                                    )
                                                })
                                            }
                                        </Nav>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </Fragment>
        );
    }
}

export default PlansContent;
